import { ReactComponent as ProcurementIcon } from '@Icons/menu/procurement.svg';

import { BaseNameSideItem } from '../../../../../enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const ProcurementsItem: MenuItem = createItem(
  BaseNameSideItem.PROCUREMENT,
  BaseNameSideItem.PROCUREMENT,
  <ProcurementIcon />
);

export default ProcurementsItem;
